import { employerRights, zywaveUserRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { generatePath } from 'react-router-dom';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import { getRootStoreInstance, RootStore } from 'store/rootStore';
import { ChecklistCard, ChecklistOption, EnrollmentCoreData, EnrollmentProposalData } from 'types/enrollmentService';
import { RouteV2Id, ROUTES_CONFIG_V2 } from 'routes/routesConfigV2';

export class PostSubmitChecklistPageStore {
  private rootStore: RootStore = getRootStoreInstance();
  private _enrollmentPeriodModule = new EnrollmentPeriodModule();

  get isLoading(): boolean {
    return this._enrollmentPeriodModule.isLoading;
  }

  get enrollmentCoreData(): EnrollmentCoreData | null {
    return this._enrollmentPeriodModule.enrollmentCoreData;
  }

  get enrollmentProposalData(): EnrollmentProposalData | null {
    return this._enrollmentPeriodModule.enrollmentProposalData;
  }

  get checklistOptions(): ChecklistOption<ChecklistCard>[] {
    return this._enrollmentPeriodModule.postSubmitChecklist?.checklistOptions || [];
  }

  get goBackUrl(): string | null {
    if (this.isLoading) {
      return null;
    }
    if (employerRights(this.rootStore.userStore.userRoles)) {
      return generatePath(ROUTES_CONFIG_V2[RouteV2Id.EMPLOYER_PROFILE].path, {
        groupId: this.enrollmentCoreData?.groupId,
      });
    }
    if (zywaveUserRights(this.rootStore.userStore.userRoles)) {
      return `/zywave-group/${this.enrollmentCoreData?.groupId}`;
    }
    return `/group/${this.enrollmentCoreData?.groupId}`;
  }

  public async loadInitialData(periodId: string): Promise<void> {
    await this._enrollmentPeriodModule.uploadEnrollmentPeriod(periodId);
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const PostSubmitChecklistPageStoreContext = createContext(new PostSubmitChecklistPageStore());

export const usePostSubmitChecklistPageStore = (): PostSubmitChecklistPageStore => {
  return useContext(PostSubmitChecklistPageStoreContext);
};

export { PostSubmitChecklistPageStoreContext };
